/* eslint-disable */
import React from 'react'

import CheckboxItem from './CheckboxItem'
import { FilterContainer, FilterTypes, Container, Content, ListItem, Title, TitleContainer } from './styles'
import CalendarIcon from '../../elements/Icons/CalendarIcon'

const filterItems = [
  {
    value: 6,
    label: 'Dom',
  },
  {
    value: 0,
    label: 'Seg',
  },
  {
    value: 1,
    label: 'Ter',
  },
  {
    value: 2,
    label: 'Qua',
  },
  {
    value: 3,
    label: 'Qui',
  },
  {
    value: 4,
    label: 'Sex',
  },
  {
    value: 5,
    label: 'Sab',
  },
]

function FilterByWeekDays(props) {
  return (
    <Container>
      <Content>
        <TitleContainer>
          <CalendarIcon/> 
          <Title>Dias da semana específicos</Title>
        </TitleContainer> 
        <FilterContainer>
          <FilterTypes>
            {filterItems.map((type, index) => {
              return(
              <ListItem key={type.value}>
                <CheckboxItem
                  setWeekDayRef={props.setWeekDayRef}
                  typeValue={type.value}
                  onChange={props.onChange}
                  name='diaDaSemana'
                  label={type.label}
                  index={index}
                />
              </ListItem>
            )})}
          </FilterTypes>
        </FilterContainer>
      </Content>
    </Container>
  )
}

export default FilterByWeekDays



// WEBPACK FOOTER //
// ./src/app/modules/FilterByWeekDays/FilterByWeekDays.js